import React, { Suspense } from 'react'
import lazyWithRetry from '../../../utils/lazyWithRetry'
import YourClassRoomSkeleton from './skeleton/YourClassRoomSkeleton'
import MonitoringSkeleton from './skeleton/MonitoringSkeleton'
import ActionsSkeleton from './skeleton/ActionsSkeleton'
import StatisticsSkeleton from './skeleton/StatisticsSkeleton'

const YourClassroom = lazyWithRetry(() => import('./overview/YourClassroom'), './overview/YourClassroom')
const Monitoring = lazyWithRetry(() => import('./overview/Monitoring'), './overview/Monitoring')
const Actions = lazyWithRetry(() => import('./overview/Actions'), './overview/Actions')
const Statistics = lazyWithRetry(() => import('./overview/Statistics'), './overview/Statistics')

function Overview() {
    return (
        <div className="flex flex-col">
            <div className="">
                <Suspense fallback={<YourClassRoomSkeleton />}>
                    <YourClassroom />
                </Suspense>
            </div>
            <div className="flex flex-row my-[10px] lg:my-[25px]">
                <Suspense fallback={<MonitoringSkeleton />}>
                    <Monitoring />
                </Suspense>
                <div className="flex-1 ml-[10px] lg:ml-[25px]">
                    <Suspense fallback={<ActionsSkeleton />}>
                        <Actions />
                    </Suspense>
                </div>
            </div>
            <div className="">
                <Suspense fallback={<StatisticsSkeleton />}>
                    <Statistics />
                </Suspense>
            </div>
        </div>
    )
}

export default Overview
